<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <CSidebarBrand class="d-md-down-none" to="/">
                    <img
                      class="c-sidebar-brand-full"
                      src="../../assets/icons/logo-normal.png"
                      size="custom-size"
                      :height="90"
                      viewBox="0 0 556 134"
                    />
                    <img
                      class="c-sidebar-brand-minimized"
                      src="../../assets/icons/logo-min.png"
                      size="custom-size"
                      :height="35"
                      viewBox="0 0 110 134"
                    />
                  </CSidebarBrand>
                  <br />
                  <CInput
                    placeholder="Nombre de usuario"
                    autocomplete="username email"
                    @input="handleUsername"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Contraseña"
                    type="password"
                    @input="handlePassword"
                    autocomplete="curent-password"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow v-if="this.mensajeError != ''">
                    <CCol style="color: red; margin-bottom: 15px">{{
                      this.mensajeError
                    }}</CCol>
                  </CRow>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton
                        color="primary"
                        @click="iniciarSesion"
                        class="px-4"
                        >Iniciar sesión</CButton
                      >
                    </CCol>
                    <CCol col="6" class="text-right">
                      <!--<CButton color="link" class="px-0">Forgot password?</CButton>
                      <CButton color="link" class="d-lg-none">Register now!</CButton>-->
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { logIn } from "../../requests/auth";
import { saveAuthData } from "../../utils/authUtils";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      mensajeError: "",
    };
  },
  methods: {
    handleUsername(event) {
      this.email = event;
    },
    handlePassword(event) {
      this.password = event;
    },
    iniciarSesion() {
      logIn(this.email, this.password)
        .then((res) => {
          saveAuthData(res.data, this.email);
          this.$router.push({ path: "/concursos/lista" });
        })
        .catch((error) => {
          this.mensajeError = "Correo o contraseña incorrectos";
        });
    },
  },
};
</script>
